'use client';
import { Column } from 'rsuite-table';
export default Column;